import React from 'react'
import { Box, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure } from '@chakra-ui/react'

interface IDeleteBtnWithConfirmation {
    deleteFn: any;
    renderBtn: any;
    onClose: any;
}

export const DeleteBtnWithConfirmation = (props: IDeleteBtnWithConfirmation) => {

    const { deleteFn, renderBtn } = props;
    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <Box onClick={onOpen}>
            {renderBtn()}
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Delete Confimation</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        Are you sure?
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="gray" mr={3} borderRadius="0.2em" onClick={onClose}>
                            No
                        </Button>
                        <Button variant="solid" colorScheme="red" borderRadius="0.2em" onClick={() => {
                            deleteFn(onClose)
                        }}>Yes</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Box>
    )
}
